import classNames from 'classnames'
import * as React from 'react'

import './Timeline.scss'

interface TimelineProps {
  direction: string
  addTime?: boolean
  numbers?: boolean
  children?: React.ReactNode | undefined
}

interface TimelineItemProps {
  current?: boolean
  onClick?: (event: Event) => void
  children?: React.ReactNode | undefined
}

interface TimelineBoxProps {
  children?: React.ReactNode | undefined
}

const Timeline: React.FC<TimelineProps> = props => {
  const className = classNames(
    'srprs-timeline',
    `direction-${props.direction}`,
    props.addTime ? 'has-time' : '',
    props.numbers ? 'has-numbers' : '',
  )

  return <ul className={className}>{props.children}</ul>
}

const TimelineBox: React.FC<TimelineBoxProps> = props => {
  const className = classNames('srprs-timeline-box')

  return <div className={className}>{props.children}</div>
}

class TimelineItem extends React.Component<TimelineItemProps, {}> {
  public static defaultProps: Partial<TimelineItemProps> = { current: false }

  constructor(props: TimelineItemProps) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  public onClick(e: any) {
    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  public render() {
    return (
      <li
        className={this.props.current ? 'is-current' : ''}
        onClick={this.onClick}
      >
        {this.props.children}
      </li>
    )
  }
}

export { Timeline, TimelineItem, TimelineBox }
